'use client';

import React, { createContext, useContext, useMemo } from 'react';
import { Toaster, toast } from 'sonner';
import 'sonner/dist/styles.css';
import { ProviderProps } from '../types/types';
const ToastContext = createContext({
  showSuccessToast: () => {},
  showErrorToast: () => {},
  showWarningToast: () => {},
  handleToastClose: () => {}
});
const useToast = () => useContext(ToastContext);
const ToastProvider = ({
  children
}) => {
  const value = useMemo(() => ({
    showSuccessToast: message => toast.success(message),
    showErrorToast: message => toast.error(message),
    showWarningToast: message => toast.warning(message),
    handleToastClose: () => toast.dismiss()
  }), []);
  return <ToastContext.Provider value={value}>
            {children}
            <Toaster position="bottom-center" duration={3000} closeButton toastOptions={{
      classNames: {
        toast: 'rounded-lg! shadow-md! border border-[#E0E0E0]! font-medium! whitespace-pre-line',
        success: 'bg-emerald-100! text-emerald-700!',
        error: 'bg-red-100! text-red-700!',
        warning: 'bg-amber-100! text-amber-700!',
        closeButton: '!right-1.5 !top-6.5 !left-auto !translate-x-0 !translate-y-0 scale-[1.3]! border-none! rounded-md! bg-black/5! text-gray-800! hover:bg-black/10! hover:text-black!'
      }
    }} />
        </ToastContext.Provider>;
};
export { ToastProvider, useToast };